"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _styling = require("../toolkit/styling");

var _providers = require("../toolkit/providers");

var _Text = _interopRequireDefault(require("./text/Text"));

//
//  src/Checkpoint.tsx
//  Project-Lego
//
//  Created by Jonah Dlin on 09/15/2020.
//  Copyright © 2020-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */
var propDoc = {};
var demoProps = {};

var Point = function Point(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: 1
    }
  }, children);
};

var Checkpoint = function Checkpoint(props) {
  var className = props.className,
      children = props.children,
      numbered = props.numbered,
      pointsMargin = props.pointsMargin,
      divProps = (0, _objectWithoutProperties2["default"])(props, ["className", "children", "numbered", "pointsMargin"]);
  var styles = useStylesheet({
    pointsMargin: pointsMargin || 24
  });

  var _useMemo = (0, _react.useMemo)(function () {
    var last;
    var firsts = [];

    var countChildren = _react["default"].Children.count(children);

    _react["default"].Children.forEach(children, function (child, index) {
      if (index === countChildren - 1) {
        last = child;
        return;
      }

      firsts.push(child);
    });

    return {
      firstPoints: firsts,
      lastPoint: last
    };
  }, [children]),
      firstPoints = _useMemo.firstPoints,
      lastPoint = _useMemo.lastPoint;

  var renderPointContainer = function renderPointContainer(point, index) {
    return (
      /*#__PURE__*/
      // using index as key as last resort. Usually checkpoints are not reordered
      _react["default"].createElement("div", {
        className: (0, _styling.css)(styles.pointContainer),
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(numbered ? styles.numberedIcon : styles.icon)
      }, numbered && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        weight: "bold"
      }, index + 1)), point)
    );
  };

  var firstPointContainers = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, firstPoints.map(function (point, index) {
    return renderPointContainer(point, index);
  }));

  var lastPointContainer = renderPointContainer(lastPoint, firstPoints.length);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _styling.css)(styles.root, className)
  }, divProps), firstPoints.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.firstPoints)
  }, firstPointContainers, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(numbered ? styles.numberedLine : styles.line)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.lastPoint)
  }, lastPointContainer));
};

Checkpoint.Point = Point;
Checkpoint.propDoc = propDoc;
Checkpoint.demoProps = demoProps;
Checkpoint.demoRender = "\n<Checkpoint>\n  <Checkpoint.Point>\n    First do this step\n  </Checkpoint.Point>\n  <Checkpoint.Point>\n    After you're done with the first step, do this step\n  </Checkpoint.Point>\n  <Checkpoint.Point>\n    Finally, do this step to finish\n  </Checkpoint.Point>\n</Checkpoint>\n  ";
Checkpoint.discussion = "\nThis component renders a list of steps in a process, as a group. The steps are\nare defined as child components, each wrapped in `Checkpoint.Point`.\n";
var _default = Checkpoint;
exports["default"] = _default;
var PointIconDiameter = 12;
var PointIconMarginTop = 4;
var LineWidth = 1;
var NumberedPointIconDiameter = 56;
var NumberedPointIconMarginTop = 0;
var NumberedLineWidth = 1;

var useStylesheet = function useStylesheet(_ref2) {
  var pointsMargin = _ref2.pointsMargin;

  var _useTheming = (0, _providers.useTheming)(),
      _useTheming$theme = _useTheming.theme,
      surfaceDark = _useTheming$theme.surfaceDark,
      primary = _useTheming$theme.primary,
      surfaceLightest = _useTheming$theme.surfaceLightest,
      borderPrimary = _useTheming$theme.borderPrimary,
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        position: "relative",
        fontFamily: fonts.regular
      },
      pointContainer: {
        display: "flex",
        ":not(:last-child)": {
          marginBottom: pointsMargin
        }
      },
      firstPoints: {
        position: "relative",
        marginBottom: pointsMargin
      },
      lastPoint: {},
      icon: {
        minWidth: PointIconDiameter,
        width: PointIconDiameter,
        height: PointIconDiameter,
        borderRadius: "100%",
        backgroundColor: surfaceDark,
        marginRight: 12,
        marginTop: PointIconMarginTop
      },
      numberedIcon: {
        position: "relative",
        zIndex: 2,
        minWidth: NumberedPointIconDiameter,
        width: NumberedPointIconDiameter,
        height: NumberedPointIconDiameter,
        border: "6px solid ".concat(borderPrimary),
        borderRadius: "100%",
        boxSizing: "border-box",
        backgroundColor: surfaceLightest,
        marginRight: 24,
        marginTop: NumberedPointIconMarginTop,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: primary,
        fontSize: 24,
        lineHeight: "32px"
      },
      line: {
        position: "absolute",
        width: LineWidth,
        height: "calc(100% + ".concat(pointsMargin, "px)"),
        top: PointIconDiameter / 2 + PointIconMarginTop,
        backgroundColor: surfaceDark,
        left: PointIconDiameter / 2 - LineWidth / 2
      },
      numberedLine: {
        position: "absolute",
        zIndex: 1,
        width: NumberedLineWidth,
        height: "calc(100% + ".concat(pointsMargin, "px)"),
        top: NumberedPointIconDiameter / 2 + NumberedPointIconMarginTop,
        backgroundColor: primary,
        left: NumberedPointIconDiameter / 2 - NumberedLineWidth / 2
      }
    });
  }, [primary, fonts.regular, surfaceDark, surfaceLightest, borderPrimary, pointsMargin]);
};